// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * We cannot easily remove these global variables, because they're used in multiple places.
 *
 * PLEASE DO NOT ADD MORE VARIABLES HERE! (Unless they're used in multiple places, too.)
 */
:root {
  --icon-size: 24px;
  --icon-size-xs: 16px;
}
:root {
  --default-font-icon-offset: -0.1; /* THEMING API */

  /* Use this variable for icons floating in text. */
  --floating-icon-transform: translateY(calc(var(--default-font-icon-offset)*1em));
}
.d-icon {
  --icon-color: currentColor;

  display: inline-block;
  flex-shrink: 0;
  height: var(--icon-size);
  margin: 0;
  vertical-align: middle;
  width: var(--icon-size);
}
:is(.d-icon path,.d-icon circle,.d-icon ellipse,.d-icon rect):where(:not([fill],[stroke])) {
      fill: var(--icon-color);
    }
.d-icon path:where([stroke]) {
    stroke: var(--icon-color);
    stroke-width: 1.5px;
  }
.d-icon.css-based-icon {
    background-color: var(--icon-color);

    /* noinspection CssUnresolvedCustomProperty */
    mask-image: var(
      --mask-image
    ); /* Variable --mask-image gets filled from icon.ts,
    that's why we ignore the rule CssUnresolvedCustomProperty here */
  }
.d-icon-xxs {
  --icon-size: 12px;
}
.d-icon-xs {
  --icon-size: var(--icon-size-xs);
}
.d-icon-s {
  --icon-size: 20px;
}
.d-icon-l {
  --icon-size: 32px;
}
.d-icon-xl {
  --icon-size: 48px;
}
.d-icon-light path {
  stroke-width: 1px;
}
.d-icon-bold path {
  stroke-width: 2px;
}
/*
 * The following classes use !important, because their only purpose is to change the icon color.
 * Without it, we had to special-case them in places where we also override the icon color.
 */
.d-icon-primary {
  color: var(--primary-color) !important;
}
.d-icon-error {
  color: var(--color-error) !important;
}
.d-icon-warning {
  color: var(--color-warning) !important;
}
.d-icon-stack {
  display: inline-block;
  height: var(--icon-size);
  position: relative;
  vertical-align: middle;
  width: var(--icon-size);
}
.d-icon-stack .d-icon {
    margin: 0;
    position: absolute;
  }
:is(.d-icon-stack .d-icon):not(.d-icon-badge) {
      left: 0;
    }
.d-icon-stack .d-icon-badge {
    bottom: -3px;
    height: 12px;
    right: -3px;
    width: 12px;
  }
`, "",{"version":3,"sources":["webpack://./src/ui/icon/icon-variables.css","webpack://./src/ui/icon/icon.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,iBAAiB;EACjB,oBAAoB;AACtB;ACNA;EACE,gCAAgC,EAAE,gBAAgB;;EAElD,kDAAkD;EAClD,gFAAkF;AACpF;AAEA;EACE,0BAA0B;;EAE1B,qBAAqB;EACrB,cAAc;EACd,wBAAwB;EACxB,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AAyBzB;AAnBI;MACE,uBAAuB;IACzB;AAGF;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AAEA;IACE,mCAAmC;;IAEnC,6CAA6C;IAC7C;;KAEC,EAAE;oEAC6D;EAClE;AAGF;EACE,iBAAiB;AACnB;AAEA;EACE,gCAAgC;AAClC;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;;;EAGE;AAEF;EACE,sCAAsC;AACxC;AAEA;EACE,oCAAoC;AACtC;AAEA;EACE,sCAAsC;AACxC;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AAiBzB;AAfE;IACE,SAAS;IACT,kBAAkB;EAKpB;AAHE;MACE,OAAO;IACT;AAGF;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;EACb","sourcesContent":["/*\n * We cannot easily remove these global variables, because they're used in multiple places.\n *\n * PLEASE DO NOT ADD MORE VARIABLES HERE! (Unless they're used in multiple places, too.)\n */\n:root {\n  --icon-size: 24px;\n  --icon-size-xs: 16px;\n}\n","@import 'ui/icon/icon-variables.css';\n\n:root {\n  --default-font-icon-offset: -0.1; /* THEMING API */\n\n  /* Use this variable for icons floating in text. */\n  --floating-icon-transform: translateY(calc(var(--default-font-icon-offset) * 1em));\n}\n\n.d-icon {\n  --icon-color: currentColor;\n\n  display: inline-block;\n  flex-shrink: 0;\n  height: var(--icon-size);\n  margin: 0;\n  vertical-align: middle;\n  width: var(--icon-size);\n\n  & path,\n  & circle,\n  & ellipse,\n  & rect {\n    &:where(:not([fill], [stroke])) {\n      fill: var(--icon-color);\n    }\n  }\n\n  & path:where([stroke]) {\n    stroke: var(--icon-color);\n    stroke-width: 1.5px;\n  }\n\n  &.css-based-icon {\n    background-color: var(--icon-color);\n\n    /* noinspection CssUnresolvedCustomProperty */\n    mask-image: var(\n      --mask-image\n    ); /* Variable --mask-image gets filled from icon.ts,\n    that's why we ignore the rule CssUnresolvedCustomProperty here */\n  }\n}\n\n.d-icon-xxs {\n  --icon-size: 12px;\n}\n\n.d-icon-xs {\n  --icon-size: var(--icon-size-xs);\n}\n\n.d-icon-s {\n  --icon-size: 20px;\n}\n\n.d-icon-l {\n  --icon-size: 32px;\n}\n\n.d-icon-xl {\n  --icon-size: 48px;\n}\n\n.d-icon-light path {\n  stroke-width: 1px;\n}\n\n.d-icon-bold path {\n  stroke-width: 2px;\n}\n\n/*\n * The following classes use !important, because their only purpose is to change the icon color.\n * Without it, we had to special-case them in places where we also override the icon color.\n */\n\n.d-icon-primary {\n  color: var(--primary-color) !important;\n}\n\n.d-icon-error {\n  color: var(--color-error) !important;\n}\n\n.d-icon-warning {\n  color: var(--color-warning) !important;\n}\n\n.d-icon-stack {\n  display: inline-block;\n  height: var(--icon-size);\n  position: relative;\n  vertical-align: middle;\n  width: var(--icon-size);\n\n  & .d-icon {\n    margin: 0;\n    position: absolute;\n\n    &:not(.d-icon-badge) {\n      left: 0;\n    }\n  }\n\n  & .d-icon-badge {\n    bottom: -3px;\n    height: 12px;\n    right: -3px;\n    width: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
